import { render, staticRenderFns } from "./OakPopup.vue?vue&type=template&id=70fdb446&scoped=true&"
import script from "./OakPopup.vue?vue&type=script&lang=js&"
export * from "./OakPopup.vue?vue&type=script&lang=js&"
import style0 from "./OakPopup.vue?vue&type=style&index=0&id=70fdb446&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fdb446",
  null
  
)

export default component.exports